import { render, staticRenderFns } from "./SetList.vue?vue&type=template&id=2a114e0f&"
import script from "./SetList.vue?vue&type=script&lang=js&"
export * from "./SetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports